import { Pagination } from './pagination';
import { Transacao } from './recebivel';
import { RecebivelUpdated} from './recebivel-updated';

export class SearchResult {
   pagination: Pagination;
   recebiveis: RecebivelUpdated[];

   constructor(recebiveis?:Array<any>, pagination?:Pagination) {
        this.recebiveis = recebiveis;
        this.pagination = pagination;
    }   
}
